import styled from "styled-components";


export const FocusCard = styled.div`
  // background: ${(props) => props.style?.background || '#F7F8FC'};
  border-radius: 10px;
  padding: 20px 20px 0;
  // margin-bottom:30px;

`;